import "twin.macro";

interface UnifiedProjectIconProps {
    classicIcon: React.ReactNode;
}

export const UnifiedProjectIcon: React.FC<UnifiedProjectIconProps> = p => {
    const { classicIcon } = p;
    return <>{classicIcon}</>;
};
